import update from 'immutability-helper';
import AnimationTypeEnum from './AnimationConstants';


const commonInitialAnimationState = {
  started: false,
  finished: false,
  step: 0,
  totalSteps: 0,
  stepInterval: 0,
};

export const initialState = {
  [AnimationTypeEnum.PROGRESS_BAR_ANIMATION]: {
    ...commonInitialAnimationState,
  },
  [AnimationTypeEnum.SELF_SERVE_BUILDER_FIELD_PLACEMENT_DONE_ANIMATION]: {
    ...commonInitialAnimationState,
    fieldIdToAnimate: null,
  },
  [AnimationTypeEnum.STATIC_BUILDER_SAVE_ANIMATION]: {
    ...commonInitialAnimationState,
    step: 40,
    totalSteps: 100,
    disabled: false,
  },
};

const AnimationReducer = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case AnimationTypeEnum.ANIMATION_UPDATE:
      return update(state, {
        [action.animationType]: {
          $merge: { ...action.updatedAnimationState },
        },
      });

    case AnimationTypeEnum.ANIMATION_START:
      return update(state, {
        [action.animationType]: {
          started: { $set: true },
          stepInterval: { $set: action.stepInterval },
          totalSteps: { $set: action.totalSteps },
        },
      });
    case AnimationTypeEnum.ANIMATION_FINISH:
      return update(state, {
        [action.animationType]: {
          finished: { $set: true },
          step: { $set: state[action.animationType].step + 1 },
        },
      });
    case AnimationTypeEnum.ANIMATION_STEP_SET:
      return update(state, {
        [action.animationType]: {
          step: { $set: action.step },
        },
      });
    default:
      return state;
  }
};

export default AnimationReducer;



// WEBPACK FOOTER //
// ./src-react/Animation/AnimationReducer.jsx